import timePeriodList from "./time-period";
import manuscript from "./manuscript";
import manuscriptTime      from "./manuscript-time";
import countries from "./country";

export default [...timePeriodList, ...manuscript, ...manuscriptTime, ...countries];
